import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import './DnevnepromjeneDonat.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';

import axios from 'axios';
import { APICall } from './services/api.service';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as actions from './redux/actions.js'
import * as useLocalStorage from './services/useLocalStorage';

const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});
function Pocetna() {


    const [curr_time, setCurrTime] = useState('');


    const [izreka, setIzreka] = useState('');

    const token = localStorage.getItem("token");

    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");

    const dispatch = useDispatch();
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)

    const navigate = useNavigate();

    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   useEffect(() => {




    getData();

    let tmp = new Date();

    console.log(tmp);

    tmp.setMinutes(tmp.getMinutes() - 25);

    console.log(tmp);

    let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + (tmp.getFullYear()) + " " + tmp.getHours() + ":" + tmp.getMinutes();

    console.log(timeNow);

    
    setCurrTime(timeNow);

    console.log("token", token)

    console.log(user);
    console.log(username);
    console.log(ref);



}, []);

    async function getData () {


   
        let unmounted = false;
        let source = axios.CancelToken.source();
   
        
        
        await APICall(
            '/GetIzreke',
            {

                 platform: '0',
                 version:'1.0'
 
             },
            {
                token
            }).then(

   
                (response) => {
    
                        if (!unmounted) {
                
   
   
   
   
                                      var dataTmp = response.data;

                                      console.log(dataTmp);
   
   
   
                                      if(dataTmp && dataTmp.izreka && dataTmp.izreka !=""){
   
   
   
             
                                                setIzreka(dataTmp.izreka);

                                                console.log(dataTmp.izreka)

                                                
                       
                                           
                                      }else{
   
         
   
                                                toast.info(dataTmp.message,
                                                     toastInfo);
                                             
             
                  
                                             
   
                                      }
               
                        }
                
                },
    
                (error) => {
    
                       if (!unmounted) {
                
                
   
   
                
                            if(!error.response){
   
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                      toastError);
                              
   
   
                            } else {
   
   
                                if (!error.response.status) {
   
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        toastError);
   
                                } else {
    
                                        if (error.response.status == 401) {
                    
                                
                                                    toast.error(error.response.data.message,
                                                            toastError);
                                                    
                                                    setTimeout(() => {
                                                            dispatch(actions.logOut())
                                                            navigate('/')
                                                    }, 5000);                             
                                
    
                                        
                                    
                                        } else {
                                    
                                    
                                                    toast.error(error.response.data.message, toastError);
                                                                                
                                            
                                        }
                                }
                            }
                        
                       }
                
                
                });
                
                
   }            
   

  return (
    <ThemeProvider theme={theme}>

        <div className="DPDonat-main-container">
            <div className={`DPDonat-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
>
                <div className="DPDonat-header-title">
                    <Typography  variant="h5">
                        VAL
                    </Typography>

                </div>
                <div className="DPDonat-header-subtitles">
                    <Typography className="DPDonat-header-subtitle" variant="p">
                   
                    </Typography>
                    <Typography className="DPDonat-header-subtitle" variant="p">
                       Korisnik: {user}
                    </Typography>
                    <Typography className="DPDonat-header-subtitle" variant="p">
                       Broj referenta: {ref}
                    </Typography>
                    <Typography className="DPDonat-header-subtitle" variant="p">
                       Prijava : {curr_time}
                    </Typography>
                </div>
            </div>

                <div className="DPDonat-form-pocetna">
                        <div style={{marginTop: "10px"}}>{izreka}</div>
                        <div style={{color: "gray", margin: "10px"}}>Davor Klobučar</div>
                </div>

      

        </div>
    </ThemeProvider >
  );
}

export default Pocetna;
